import { render, staticRenderFns } from "./ku-image.vue?vue&type=template&id=096bae5f"
import script from "./ku-image.vue?vue&type=script&lang=js"
export * from "./ku-image.vue?vue&type=script&lang=js"
import style0 from "./ku-image.vue?vue&type=style&index=0&id=096bae5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports